export default {
  Secret: "密钥"
};
